import styled from "@emotion/styled";
import {
  Button,
  Checkbox,
  Dialog,
  IconButton,
  LinearProgress,
  Select,
  TextField,
  ToggleButtonGroup,
  Tooltip,
} from "@mui/material";
import { font } from "../font";
import { theme } from "../theme";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
export const TextFieldMA = styled(TextField)({
  "& label.Mui-focused": {
    color: theme.col_2,
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: theme.col_2,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: theme.col_2,
    },
    "&:hover fieldset": {
      borderColor: theme.col_2,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.col_2,
    },
  },
});

export const SelectMA = styled(Select)({
  ".MuiOutlinedInput-notchedOutline": {
    borderColor: theme.col_2,
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.col_2,
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.col_2,
  },
  "& label.Mui-focused": {
    color: theme.col_2,
  },
});

// export const AccordionMA = styled(Accordion)({
//   border: `1px solid ${theme.col_3}`,
//   '&:not(:last-child)': {
//     borderBottom: 0,
//   },
//   '&::before': {
//     display: 'none',
//   }

// });

export const DialogMA = styled(Dialog)({
  '.MuiDialog-paper':{width:'430px'}
})


export const AccordionMA = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
  border: `1px solid ${theme.col_2_alpha}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
  "&.MuiAccordion-root.Mui-disabled": { background: theme.col_2_alpha2 },
}));

export const AccordionSummaryMA = styled((props) => (
  <MuiAccordionSummary
    expandIcon={
      <ArrowForwardIosSharpIcon
        sx={{ fontSize: font.size.fs_3, color: `${theme.col_2} !important` }}
      />
    }
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "rgba(255, 255, 255, .05)",
  // flexDirection: 'row-reverse',
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: "6px",
  },
}));

export const AccordionDetailsMA = styled(MuiAccordionDetails)(() => ({
  padding: "0px",
  borderTop: `1px solid ${theme.col_2_alpha}`,
  borderBottom: `1px solid ${theme.col_2_alpha}`,
  color: theme.col_2,
  overflow: "hidden",
  ".Mui-expanded": {
    background: "red",
    borderRadius: "12px !important",
    border: "1px solid red !important",
  },
}));

export const ButtonMA = styled(Button)({
  background: theme.col_2,
  color: "white",
  "&:hover": { background: theme.col_2 },
});

export const IconButtonMA = styled(IconButton)({
  // background: theme.col_2,
  background: theme.col_2_alpha,
  color: theme.col_2,
  "&:hover": { background: theme.col_2_alpha },
});

export const ButtonNavigation = styled(Button)({
  //   background: theme.col_2_alpha,
  ".MuiButton-startIcon": { width: "25px", height: "25px" },
  width: "88%",
  borderRadius: "0px 20px 20px 0px",
  "&:hover": { background: theme.col_1 },
  // '&:focus':{background:theme.col_2},
  ".MuiTouchRipple-child": {
    background: `${theme.col_2} !important`,
  },
});

export const CheckboxMA = styled(Checkbox)({
  "&.Mui-checked": { color: theme.col_2 },
});

export const ToggleButtonGroupMA = styled(ToggleButtonGroup)({
  ".MuiToggleButtonGroup-grouped": {
    color: theme.col_3,
    borderRadius: "40px",
    fontFamily: font.family.fm_1,
    textTransform: "capitalize",
  },
  // borderRadius:'12px'
});

export const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export const TooltipMA = styled(Tooltip)({});


export const LinearProgressMA = styled(LinearProgress)({
  // '.MuiLinearProgress-root':{
  //   width:'80%',
  //   height:'23px',
  //   // background:'red',

  // },
  // backgroundColor:'red'
  '&.MuiLinearProgress-bar':{
    backgroundColor:'red !important'
  },
  '&.MuiLinearProgress-bar2':{
    backgroundColor:'red !important'
  }
})
